// extracted by mini-css-extract-plugin
export default {"wrapper":"Empty_wrapper__EFqAD"};